"use strict";

exports.__esModule = true;
var _UpdateUserScreen = require("./UpdateUserScreen");
Object.keys(_UpdateUserScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateUserScreen[key]) return;
  exports[key] = _UpdateUserScreen[key];
});